import React from 'react';
import TradingViewCoursesWireframe from '../../components/wireframes/TradingViewCoursesWireframe.jsx';

const WireframeDemo = () => {
  return (
    <div className="w-full h-screen">
      <TradingViewCoursesWireframe />
    </div>
  );
};

export default WireframeDemo;
